import {
  PREMIUM_CLOSE_TO,
  PREMIUM_HIGHER_THAN,
  PREMIUM_LESSER_THAN,
} from '@quantiply/common/constants';
import { getTextWidth } from './element-size';

export const premiumTypeOptions = [
  {
    label: 'Legs',
    value: 'STRIKE',
  },
  {
    label: 'Premium close to',
    value: PREMIUM_CLOSE_TO,
  },
  {
    label: 'Premium > than',
    value: PREMIUM_HIGHER_THAN,
  },
  {
    label: 'Premium < than',
    value: PREMIUM_LESSER_THAN,
  },
  {
    label: 'ATM %',
    value: 'ATM_PERCENT',
  },
  {
    label: 'Straddle width',
    value: 'STRADDLE_WIDTH',
  },
  {
    label: 'Straddle premium',
    value: 'STRADDLE_PREMIUM',
  },
  {
    label: '% of Underlying',
    value: 'UNDERLYING_PC',
  },
  {
    label: 'Specific strike',
    value: 'SP',
  },
];

export const setLegsPremiumWidth = (data) => {
  const { legs = [] } = data?.data?.configurations || {};
  let longestLabel = '';
  const mainContainerMinWidth = 70;

  legs.forEach((l) => {
    let selectedlabel = '';
    if (l.selectionType === 'PREMIUM') {
      const { premium = {} } = l || {};
      const { type = '' } = premium;
      const { label = '' } =
        premiumTypeOptions.find((o) => o.value === type) || {};

      selectedlabel = label;
    } else {
      const { label = '' } =
        premiumTypeOptions.find((o) => o.value === l?.selectionType) || {};

      selectedlabel = label;
    }

    if (selectedlabel && selectedlabel.length > longestLabel.length) {
      longestLabel = selectedlabel;
    }
  });

  if (!longestLabel) {
    longestLabel = premiumTypeOptions[0].value;
  }

  let mainContainerWidth = parseInt(getTextWidth(longestLabel), 10);
  mainContainerWidth = mainContainerWidth + 30;
  mainContainerWidth =
    mainContainerMinWidth > mainContainerWidth
      ? mainContainerMinWidth
      : mainContainerWidth;

  document.documentElement.style.setProperty(
    `--legs-premium-main`,
    `${mainContainerWidth}px`
  );

  document.documentElement.style.setProperty(
    `--legs-premium-multi-row`,
    `${mainContainerWidth}px`
  );

  // Secondary container
  const isSomeStraddlePremium = legs.some(
    (l) => l.selectionType && l.selectionType === 'STRADDLE_PREMIUM'
  );

  const isSomeStraddleWidth = legs.some(
    (l) => l.selectionType && l.selectionType === 'STRADDLE_WIDTH'
  );

  const isSomeAtmPercentage = legs.some(
    (l) => l.selectionType && l.selectionType === 'ATM_PERCENT'
  );

  const isSomePremium = legs.some(
    (l) => l.selectionType && l.selectionType === 'PREMIUM'
  );

  const isSomeUnderlyingPercentage = legs.some(
    (l) => l.selectionType && l.selectionType === 'UNDERLYING_PC'
  );

  const isSpecificStrike = legs.some(
    (l) => l.selectionType && l.selectionType === 'SP'
  );

  let secondaryContainerWidth = 70;

  if (isSomeStraddlePremium) {
    secondaryContainerWidth = 160;
  } else if (isSomeStraddleWidth) {
    secondaryContainerWidth = 120;
  } else if (isSpecificStrike) {
    secondaryContainerWidth = 140;
  } else if (isSomeAtmPercentage) {
    secondaryContainerWidth = 90;
  } else if (isSomeUnderlyingPercentage) {
    secondaryContainerWidth = 70;
  } else if (isSomePremium) {
    secondaryContainerWidth = 55;
  }

  document.documentElement.style.setProperty(
    `--legs-premium-secondary`,
    `${secondaryContainerWidth}px`
  );

  if (secondaryContainerWidth > mainContainerWidth) {
    document.documentElement.style.setProperty(
      `--legs-premium-multi-row`,
      `${secondaryContainerWidth}px`
    );
  }
};
